import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const ENTRATAFI = {
  ROOT: `${PRIVATE_ROOT}/community/entratafi`,
  REQUESTED: `${PRIVATE_ROOT}/community/entratafi/requested`,
  SERVICE_OPTIONS: `${PRIVATE_ROOT}/community/entratafi/:id/plan-options`,
  SCHEDULE_SERVICE: `${PRIVATE_ROOT}/community/entratafi/:id/add-schedule-service/:serviceId`,
  ADD_SERVICE: `${PRIVATE_ROOT}/community/entratafi/:id/option-detail/:serviceId`,
  UPDATE_SCHEDULE_SERVICE: `${PRIVATE_ROOT}/community/entratafi/:id/update-schedule-service/:serviceId`,
  SSID: `${PRIVATE_ROOT}/community/entratafi/ssid`,
  ADD_SSID: `${PRIVATE_ROOT}/community/entratafi/ssid/add`,
  EDIT_SSID: `${PRIVATE_ROOT}/community/entratafi/:id/edit`
}